// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","prices":"prices-1v2uH","price__totalTitle":"price__totalTitle-3Fn2o","money":"money-1FfDf","price__row":"price__row-1GcZq"};